<template>
  <div class="spinner"></div>
</template>

<script>
export default {
    name: 'Spinner',
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/Spinner.vue